"use client";

import { Box } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";

/** Mount children only when the placeholder enters (or nears) the viewport. */
export function SLDeferredMount({
  children,
  minHeight = 320,
  rootMargin = "240px",
  placeholder,
}: {
  children: ReactNode;
  minHeight?: number;
  rootMargin?: string;
  placeholder?: ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setMounted(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <Box ref={ref} sx={{ minHeight: mounted ? undefined : minHeight }}>
      {mounted
        ? children
        : (placeholder ?? (
            <Box sx={{ minHeight, bgcolor: "grey.100" }} aria-hidden />
          ))}
    </Box>
  );
}
